import {BrowserModule} from "@angular/platform-browser";
import {APP_INITIALIZER, NgModule} from "@angular/core";

import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {LoginComponent} from "./priLoginComp/login/login.component";
import {ResetPasswordComponent} from "./priLoginComp/reset-password/reset-password.component";
import {ForgotPasswordComponent} from "./priLoginComp/forgot-password/forgot-password.component";
import {HeaderComponent} from "./sharedComp/header/header.component";

import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi,} from "@angular/common/http";
import {OidcSecurityService, provideAuth, StsConfigLoader} from "angular-auth-oidc-client";

import {ResetForgotPasswordComponent} from "./priLoginComp/reset-forgot-password/reset-forgot-password.component";
import {SuccessMsgComponent} from "./sharedComp/success-msg/success-msg.component";
import {ForgotPasswordSuccessComponent} from "./sharedComp/forgot-password-success/forgot-password-success.component";
import {EmailPageComponent} from "./priLoginComp/email-page/email-page.component";
import {AuthorizeComponent} from "./priLoginComp/authorize/authorize.component";
import {LoginSuccessComponent} from "./sharedComp/login-success/login-success.component";
import {SpinnerInterceptorService} from "./interceptor/spinner-interceptor.service";
import {ErrorInterceptorService} from "./interceptor/error-interceptor.service";
import {CookieConsentComponent} from "./sharedComp/cookie-consent/cookie-consent.component";
import {FlexLayoutModule} from "ng-flex-layout";

import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";

import {MaterialModule} from "./material/material/material.module";
import {ReactiveFormsModule} from "@angular/forms";
import {LocalStsConfigLoader} from "./priLoginComp/service/local-sts-config-loader";
import {environment} from "../environments/environment";
import {CustomStsConfigLoader} from "./priLoginComp/service/custom-sts-config-loader";

function initializeAuth(oidcSecurityService: OidcSecurityService): () => Promise<any> {
  return () => oidcSecurityService.checkAuth().toPromise();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    HeaderComponent,
    ResetForgotPasswordComponent,
    SuccessMsgComponent,
    ForgotPasswordSuccessComponent,
    EmailPageComponent,
    AuthorizeComponent,
    LoginSuccessComponent,
    CookieConsentComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
  ],

  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    LocalStsConfigLoader,
    provideAuth({
      loader: {
        provide: StsConfigLoader,
        useClass: environment.local ? LocalStsConfigLoader : CustomStsConfigLoader,
      }
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [OidcSecurityService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true,
    },
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {

}

